import React from 'react';
import useDialog from '../hooks/useDialog';

const Dialog = ({ isOpen = true, onClose, labelledBy, className = '', style, initialFocusRef, children }) => {
  const dialogRef = useDialog({ isOpen, onClose, initialFocusRef });

  return (
    <>
      {isOpen && (
        <div className="modal-overlay" onClick={onClose}>
          <div
            className={`modal-content ${className}`.trim()}
            style={style}
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby={labelledBy}
            tabIndex={-1}
            ref={dialogRef}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default Dialog;